import dayjs from 'dayjs'
import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { RootState } from 'stores'
import { clearCourseState, fetchKDTKlassAttrThunk } from 'stores/courses'

import { checkServerKdtApplyStatus } from '../utils/checkServerKdtApplyStatus'

export const useKDTAttr = (klassId: string) => {
  const dispatch = useDispatch()

  const { isLoading, kdtAttr } = useSelector((state: RootState) => state.courses)
  const [applyStatus, setApplyStatus] = useState<string | null>(null)

  const apiVersion = kdtAttr?.apiVersion

  useEffect(() => {
    dispatch(fetchKDTKlassAttrThunk(klassId))
  }, [klassId])

  useEffect(() => {
    const today = dayjs()

    if (kdtAttr) {
      const isKDTPeriod = today.isBetween(kdtAttr.startedAt, kdtAttr.endedAt)

      if (isKDTPeriod && apiVersion !== 'v3') {
        return setApplyStatus('participation')
      }
      const status = checkServerKdtApplyStatus(kdtAttr)
      setApplyStatus(status)
    }
  }, [kdtAttr])

  const onClearKDTAttr = () => dispatch(clearCourseState())

  return {
    isLoading,
    kdtAttr,
    applyStatus,
    applyPeriodList: {
      apply: { applyStartedAt: kdtAttr?.applyStartedAt, applyEndedAt: kdtAttr?.applyEndedAt },
      assignment: {
        assignmentStartedAt: kdtAttr?.kdtAttr.assignmentStartedAt,
        assignmentEndedAt: kdtAttr?.kdtAttr.assignmentEndedAt,
      },
      participation: {
        participationStartedAt: kdtAttr?.kdtAttr.participationStartedAt,
        participationEndedAt: kdtAttr?.kdtAttr.participationEndedAt,
      },
      startedAt: kdtAttr?.startedAt,
      endedAt: kdtAttr?.endedAt,
    } as { [status: string]: { [dateKey: string]: string } | string },
    onClearKDTAttr,
  }
}
